import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useImmer } from "use-immer";

import { IgButton } from "@intelligems/ig-theme";
import { SettingsOutlined } from "@mui/icons-material";
import { Grid, Menu, MenuItem } from "@mui/material";
import { useIsMutating } from "@tanstack/react-query";

import { useEndExperience } from "../../../api/experience-actions/end-experience";
import { getExperienceDtoFromFe } from "../../../api/formatters/from-dto/experiences/experiences";
import { buildEditUrlPath } from "../../../features/experienceTests/utils/utils";
import { setDialog } from "../../../store/slices/global";
import theme from "../../../theme";
import { ExperienceFe } from "../../../types/schemas/experiences";

interface ModifyExperienceProps {
  currExperience: ExperienceFe;
}
export const ModifyExperience = ({ currExperience }: ModifyExperienceProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isEndExperienceMutating = useIsMutating({
    mutationKey: ["endExperience"],
  });
  const endExperience = useEndExperience(true, currExperience!.id);
  const [anchorEl, setAnchorEl] = useImmer<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onStopClick = () => {
    handleClose();

    if (currExperience.testTypes.hasTestShipping) {
      dispatch(setDialog({ dialog: "endShippingTest", open: true }));
    } else if (currExperience.testTypes.hasTestPricing) {
      dispatch(
        setDialog({
          dialog: "priceUpdater",
          open: true,
          props: { action: "end" },
        })
      );
    } else {
      // Campaign Test / Content
      endExperience.mutate({
        body: { variationId: undefined },
        queryParams: undefined,
        pathParams: {
          experienceId: currExperience.id!,
          name: currExperience.name!,
          action: "end",
        },
      });
    }
  };
  const onEditGroupsClick = () => {
    handleClose();
    dispatch(setDialog({ dialog: "editTestGroups", open: true }));
  };
  return (
    <Grid item>
      <IgButton
        loading={Boolean(isEndExperienceMutating)}
        variant={"outlined"}
        sx={{
          color: theme.palette.gray.main,
          border: `1px solid ${theme.palette.disabled.main}`,
          backgroundColor: "white",
        }}
        startIcon={<SettingsOutlined />}
        onClick={handleClick}
      >
        Modify Test
      </IgButton>
      <Menu
        id="modify-test-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem sx={{ fontSize: "14px" }} onClick={onEditGroupsClick}>
          Edit Test Groups
        </MenuItem>
        <MenuItem sx={{ fontSize: "14px" }} onClick={onStopClick}>
          Stop Test
        </MenuItem>
        <MenuItem
          sx={{ fontSize: "14px" }}
          onClick={() => {
            navigate(buildEditUrlPath(getExperienceDtoFromFe(currExperience)));
          }}
        >
          Go to Test Setup
        </MenuItem>
      </Menu>
    </Grid>
  );
};
